function formatPhone(phone) {
    const areaCode = '972';
    return phone.startsWith(areaCode) ? `0${phone.substring(areaCode.length)}` : phone;
}

export default formatPhone;